import React from "react";
import styles from "./AuthenticationDialog.module.scss";
import connect from "react-redux/es/connect/connect";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from "react-router-dom"
import {SyntaxHighlighter} from "ui-components"

const authBodyFederationJsonText =
`{
    "grant_type": "refresh_token",
    "refresh_token": "YOUR_REFRESH_TOKEN",
    "client_id": "${window.__auth__.refreshTokenClientId}"
}`;

const authBodyRegularJsonText =
    `{
    "grant_type": "password",
    "username": "YOUR_EMAIL_ADDRESS",
    "password": "YOUR_PASSWORD",
    "audience": "${window.__auth__.audience}",
    "client_id": "${window.__auth__.clientId}"
}`;

const AuthenticationDialog = ({closeDialog, dialogState, switchToRefreshTokenState, switchToAuthenticationState}) => {
    return <div className={styles.base}>
        <header>
            Authentication Information
        </header>
        <div className="dialog-content">
            <p>
                NetApp Cloud Central Services use OAuth 2.0, an industry-standard protocol, for authorization.
            </p>
            <p>
                Communicating with an authenticated endpoint is a two step-process.
            </p>
            <ol>
                <li>Acquire a JWT access token from the OAuth token endpoint.</li>
                <li>Call an API endpoint with the JWT access token.</li>
            </ol>
            <p>Non-federated users can use regular access or refresh token access, federated users must use refresh token access.</p>
            <div className={styles["switch-tab"]}>
                <button disabled={dialogState === "AUTHENTICATION"} onClick={switchToAuthenticationState}>Regular Access</button>
                <button disabled={dialogState === "REFRESH-TOKEN"} onClick={switchToRefreshTokenState}>Refresh Token Access (Required for federated users)</button>
            </div>
            {dialogState === "AUTHENTICATION" && <div>
                <h4>How to Acquire a JWT Access Token via regular token access</h4>
                <ol>
                    <li>
                        <div>Make an HTTP POST request to the endpoint <pre style={{display: "inline-block"}}>https://{window.__auth__.domain}/oauth/token</pre></div>
                        <div>Include the header <pre style={{display: "inline-block"}}>Content-Type: application/json</pre></div>
                        <div>Include the body:</div>
                        <div style={{position: "relative"}}>
                            <SyntaxHighlighter language='json'>{authBodyRegularJsonText}</SyntaxHighlighter>
                            <CopyToClipboard text={authBodyRegularJsonText}><button className="primary" style={{position: "absolute", top: 0, right: 0}}>Copy to clipboard</button></CopyToClipboard>
                        </div>
                    </li>
                    <li>Extract the <pre style={{display: "inline-block"}}>access_token</pre> from the response</li>
                </ol>
                <p style={{fontSize: 14, marginLeft: 25}}>Note: Certain applications may require a different audience or different clientID. Please refer to each service's specific API documentation for more information.</p>
            </div>}
            { dialogState === "REFRESH-TOKEN" &&<div>
                <h4>How to Acquire a JWT Access Token via refresh token access (Required for federated users)</h4>
                <ol>
                    <li>Generate a long-lived refresh token from the <Link to="/refresh-token">Refresh Token Generator</Link></li>
                    <li>
                        <div>Make an HTTP POST request to the endpoint <pre style={{display: "inline-block"}}>https://{window.__auth__.domain}/oauth/token</pre></div>
                        <div>Include the header: <pre style={{display: "inline-block"}}>Content-Type: application/json</pre></div>
                        <div>Include the body:</div>
                        <div style={{position: "relative"}}>
                            <SyntaxHighlighter language='json'>{authBodyFederationJsonText}</SyntaxHighlighter>
                            <CopyToClipboard text={authBodyFederationJsonText}><button className="primary" style={{position: "absolute", top: 0, right: 0}}>Copy to clipboard</button></CopyToClipboard>
                        </div>
                    </li>
                    <li>Extract the <pre style={{display: "inline-block"}}>access_token</pre> from the response</li>
                </ol>
            </div>}
            <h4>How to use a JWT Access Token</h4>
            <ol>
                <li>
                    Include the following header in all calls to an authenticated endpoint. <pre style={{display: "inline-block"}}>Authorization: Bearer YOUR_TOKEN</pre>
                </li>
            </ol>
        </div>
        <div className="button-row">
            <button onClick={closeDialog} className="dialog-button">
                Close
            </button>
        </div>
    </div>
};

const mapStateToProps = state => {
    return {
        dialogState: state.developerHub.authenticationDialogState
    };
};

const mapDispatchToProps = dispatch => {
    return {
        switchToRefreshTokenState: () => {
            dispatch({
                type: "DEVELOPER-HUB:SWITCH-STATE-REFRESH-TOKEN"
            })
        },
        switchToAuthenticationState: () => {
            dispatch({
                type: "DEVELOPER-HUB:SWITCH-STATE-AUTHENTICATION"
            })
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationDialog)